import { combineReducers } from '@reduxjs/toolkit'

import { reducers } from '@gocanvas/client'
import { clientSettingsReducer } from 'apps/web-forms/store/reducers/settings/clientSettings'

import { builderReducers as formsCreationKitReducers } from 'apps/formsCreationKit/store/reducers'
const { liveDataSources, dataSourceContexts } = formsCreationKitReducers

const rootReducer = combineReducers({
  ...reducers,
  clientSettings: clientSettingsReducer,
  liveDataSources,
  dataSourceContexts
})

export default rootReducer
